import styles from "./articleCardAuthorRow.module.scss";
import { CommentSVG, ShareSVG } from "../../svg";
import RouterLink from "../link/RouterLink";
import { authorUrlFromSlug } from "../../helpers/URLHelpers";

function ArticleCardAuthorRow({
  authors,
  withClass,
  withAuthorClass,
  enableSocialSharing,
  enableComments,
  commentCount,
  whiteText,
  withShareClassName,
  withCommentsClassName,
}) {
  return (
    <div className={`${styles.root} ${withClass}`}>
      <div className={`${styles.authors}`}>
        {authors
          ? authors.map((a) => (
              <div
                key={a.uuid}
                className={
                  `${styles.author}` +
                  (withAuthorClass ? ` ${withAuthorClass}` : "") +
                  (whiteText ? ` ${styles.whiteText}` : "")
                }
              >
                <RouterLink to={authorUrlFromSlug(a.slug)}>{a.name}</RouterLink>
              </div>
            ))
          : null}
      </div>
      <div
        className={
          (whiteText ? `${styles.whiteText}` : "") + ` ${styles.social}`
        }
      >
        {enableSocialSharing ? (
          <button
            className={`limit-visibility hidden flex-center-children ${
              withShareClassName || ""
            }`}
          >
            <ShareSVG />
          </button>
        ) : null}
        {enableComments ? (
          <button
            className={`${
              styles.comments
            } limit-visibility hidden flex-center-children ${
              withCommentsClassName || ""
            }`}
          >
            {commentCount}
            <CommentSVG />
          </button>
        ) : null}
      </div>
    </div>
  );
}

export default ArticleCardAuthorRow;
